import { render, staticRenderFns } from "./postExport.vue?vue&type=template&id=0b45ba1f&"
import script from "./postExport.vue?vue&type=script&lang=js&"
export * from "./postExport.vue?vue&type=script&lang=js&"
import style0 from "./postExport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "postExport.vue"
export default component.exports